export default __webpack_public_path__ + "static/media/icon1.5596f9fb.svg";